<script lang="ts">
  import AUButtonIcon from "component_library/components/svelte/ui/AUButtonIcon.svelte"
  import AUStack from "component_library/components/svelte/ui/AUStack.svelte"
  import { getContext } from "svelte"
  import { getFlowsContext } from "website_script/contexts/flows"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { ElementData } from "website_script/lib/Parsers"
  import { Settings } from "website_script/types/settings"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import AUText from "component_library/components/svelte/ui/AUText.svelte"
  import AULink from "component_library/components/svelte/ui/AULink.svelte"
  import { Environment } from "website_script/types/environment"
  import { ButtonConfig } from "website_script/types/widgets"
  import type { Texts } from "website_script/types/texts"
  import Star from "@autouncle/icons/dist/assets/star.svg?raw"
  import Svg from "website_script/components/Svg.svelte"

  export let elementData: ElementData

  const { trackFunction } = getContext<Environment>("environment")
  const { conversionBox }: Texts = getContext("texts")
  const { triggerFlow } = getFlowsContext()

  const {
    conversionBoxDealerRating: { rating, ratingCount },
    conversionBoxDealerRatingUrl,
    customerName,
    customerLogo,
    conversionBoxDealerInfoButtonsConfig,
  } = getContext<Settings>("settings")

  const { buttons: additionalButtons } = conversionBoxDealerInfoButtonsConfig

  additionalButtons.length &&
    trackFunction({
      entity: "conversion-box",
      element: "dealer-info",
      action: "displayed",
      flow: additionalButtons.map((b) => b.flow_type),
      type: "displayed_cta",
    })

  const _triggerFlow = (buttonConfig: ButtonConfig) => {
    triggerFlow(
      buttonConfig,
      IntegrationTypes.CONVERSION_BOX,
      undefined,
      elementData
    )
    trackFunction({
      entity: "conversion-box",
      element: "dealer-info",
      action: "clicked",
      flow: buttonConfig.flow_type,
      type: "interacted_with_cta",
    })
  }
</script>

<AUStack layout="horizontal" alignItems="center" gap="sm">
  <div class="au-conversion-box__dealer-logo">
    {#if customerLogo}
      <div class="au-conversion-box__dealer-image">
        <img src={customerLogo} alt={customerName} />
      </div>
    {/if}
    <span />
  </div>
  <div class="au-conversion-box__dealer">
    <AUText ellipsis={true} weight="bold" font="body-small"
      >{customerName}</AUText
    >

    {#if rating > 0 && ratingCount > 0}
      {#if conversionBoxDealerRatingUrl}
        <AULink
          href={conversionBoxDealerRatingUrl}
          target="_blank"
          onClick={() => {
            trackFunction({
              entity: "conversion-box",
              element: "dealer-info",
              action: "clicked",
              details: "rating",
              type: "interacted_with_cta",
            })
          }}
        >
          <div class="au-conversion-box__dealer-rating">
            <Svg data={Star} color="#F2CF42" aria-hidden="true" width="24px" />

            <AUText color="default" font="body-small" weight="bold"
              >{rating}</AUText
            >
            <AUText color="body" font="body-small"
              >({ratingCount} {conversionBox.total})</AUText
            >
          </div>
        </AULink>
      {:else}
        <div class="au-conversion-box__dealer-rating">
          <Svg data={Star} color="#F2CF42" aria-hidden="true" width="24px" />
          {rating}
          <AUText color="body" font="body-small"
            >({ratingCount} {conversionBox.total})</AUText
          >
        </div>
      {/if}
    {/if}
  </div>
  <AUStack layout="horizontal" gap="none">
    {#each additionalButtons as buttonConfig}
      <AUButtonIcon
        sroText={buttonConfig.text}
        icon={leadFlowIcon(buttonConfig.icon)}
        color={"secondary"}
        onClick={() => _triggerFlow(buttonConfig)}
      />
    {/each}
  </AUStack>
</AUStack>

<style>
  .au-conversion-box__dealer {
    flex-grow: 1;
    min-width: 0;
  }

  .au-conversion-box__dealer-logo {
    position: relative;
  }

  .au-conversion-box__dealer-image {
    border-radius: 100%;
    border: 1px solid var(--au-button-secondary-border-color);
    width: 40px;
    height: 40px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .au-conversion-box__dealer-logo img {
    width: 100%;
    height: auto;
  }

  .au-conversion-box__dealer-logo span {
    position: absolute;
    right: 0;
    bottom: 4px;
    border-radius: 100%;
    outline: 2px solid white;
    background-color: green;
    display: inline-block;
    width: 6px;
    height: 6px;
  }

  .au-conversion-box__dealer-rating {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
</style>
